import Menu from '../../components/Menu/Menu.vue'

export default {
  components: {
    Menu,
  },
  computed: {
  },
  data () {
    return {
      openMenu: false,
      showed: [],
    }
  },
  methods: {
    toogleMenu () {
      this.openMenu = !this.openMenu
    },
    onClick (i) {
      const index = this.showed.indexOf(i)
      if (index === -1) {
        this.showed.push(i)
      } else {
        this.showed.splice(index, 1)
      }
    }
  },
}
